import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getVotes, createVote, updateVote, deleteVote } from '../api/votes';
import type { VoteAggregate } from '../types/mjai';
import type { VotePayload } from '../api/votes';

export function useVotes(handId: string | undefined) {
  return useQuery<VoteAggregate>({
    queryKey: ['votes', handId],
    queryFn: () => getVotes(handId!),
    enabled: !!handId,
  });
}

export function useCreateVote(handId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: VotePayload) => createVote(handId, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['votes', handId] }),
  });
}

export function useUpdateVote(handId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Partial<VotePayload>) => updateVote(handId, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['votes', handId] }),
  });
}

export function useDeleteVote(handId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => deleteVote(handId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['votes', handId] }),
  });
}
